// extracted by mini-css-extract-plugin
export default {"skeleton":"clients_skeleton__CGLDI"};